import { usePrivy, useWallets } from "@privy-io/react-auth";
import { useAuth } from "contexts/authContext";
import { BigNumber } from "ethers";
import { ACCESS_TOKEN, getItem } from "local-storage";
import slugs from "navigation/slugs";
import { useCallback, useEffect, useState } from "react";
import { redirect } from "react-router";
import {
  getTiktokUserHoldingsById,
  getUserProfileData,
  getUserStatisticData,
} from "services/apis/apis";
import { appConfig } from "services/blockchain";

export const useController = () => {
  const { updateToken } = useAuth();
  const { authenticated, user, logout } = usePrivy();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState<any>({});
  const [balance, setBalance] = useState(BigNumber.from(0));
  const [tradingFeeEarned, setTradingFeeEarned] = useState("0");
  const [portfolioValue, setPortfolioValue] = useState("0");

  useEffect(() => {
    if (!authenticated) {
      updateToken("");
      redirect(slugs.login);
    }
  }, [authenticated, updateToken]);

  const getUserProfile = useCallback(async () => {
    try {
      const accessToken = getItem(ACCESS_TOKEN) || "";
      if (!accessToken) return;
      setIsLoading(true);
      const res = await getUserProfileData(accessToken);
      setData(res);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    getUserProfile();
  }, [getUserProfile]);

  const { wallets } = useWallets();
  const embeddedWallet = wallets.find(
    (wallet) => wallet.walletClientType === "privy"
  );

  const walletAddress = embeddedWallet?.address;

  useEffect(() => {
    const getBalanceBase = async () => {
      if (!embeddedWallet) return;
      await embeddedWallet.switchChain(8453);
      const balance = await appConfig.provider.getBalance(
        embeddedWallet?.address
      );
      setBalance(balance);
    };
    getBalanceBase();
  }, [embeddedWallet]);

  useEffect(() => {
    const f = async () => {
      const accessToken = getItem(ACCESS_TOKEN) || "";
      if (!accessToken) return;
      setIsLoading(true);
      try {
        const res = await getUserStatisticData(accessToken);
        setTradingFeeEarned(res?.trading_fee_earned);
      } catch (error) {
        console.log("🚀 ~ file: Controller.ts:79 ~ f ~ error:", error);
      }
      setIsLoading(false);
    };
    f();
  }, []);

  useEffect(() => {
    const f = async () => {
      const accessToken = getItem(ACCESS_TOKEN) || "";
      if (!accessToken || !data?.tiktok_user_id) return;
      try {
        setIsLoading(true);
        const result = await getTiktokUserHoldingsById(
          accessToken,
          data?.tiktok_user_id!
        );
        const portfolioValue = result.reduce((acc: any, cur: any) => {
          return acc + Number(cur?.total_shares) * cur?.current_price;
        }, 0);
        setPortfolioValue(portfolioValue);
      } catch (error) {
        console.log("🚀 ~ file: HoldCard.tsx:21 ~ f ~ error:", error);
      } finally {
        setIsLoading(false);
      }
    };
    f();
  }, [data?.tiktok_user_id]);

  return {
    user,
    data,
    tradingFeeEarned,
    isLoading,
    balance,
    walletAddress,
    portfolioValue,
  };
};
